import { render } from "./AppIcon.vue?vue&type=template&id=4bcc21a8&scoped=true&ts=true"
import script from "./AppIcon.vue?vue&type=script&lang=ts"
export * from "./AppIcon.vue?vue&type=script&lang=ts"

import "./AppIcon.vue?vue&type=style&index=0&id=4bcc21a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcc21a8"]])

export default __exports__